import { SectionHeader } from '../components/SectionHeader';
import { services } from '../data/services';
import styles from './Services.module.css';

export function Services() {
  return (
    <section id="services" className="band band--alt">
      <div className="container content">
        <SectionHeader
          prompt="$ ls -la ./services"
          title="Services"
          intro="From the first idea to production and beyond. We handle the full stack so you can focus on your business."
        />
        <div className={styles.grid}>
          {services.map((s) => (
            <article key={s.name} className={styles.card}>
              <div className={styles.perm} aria-hidden="true">
                drwxr-xr-x
              </div>
              <h3 className={styles.name}>{s.name}</h3>
              <p className="copy">{s.copy}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
